<template>
  <div class="discount">
    <ErrorScreen v-if="errored" />
    <LoadingScreen v-if="loading" />
    <DiscountDetails v-if="!loading && !errored" :discount="discount" />
  </div>
</template>

<script>
import ErrorScreen from "@/components/ErrorScreen.vue";
import LoadingScreen from "@/components/LoadingScreen.vue";
import DiscountDetails from "@/components/discount/DiscountDetails.vue";

export default {
  name: "Discount",

  components: {
    ErrorScreen,
    LoadingScreen,
    DiscountDetails
  },

  data: function() {
    return {
      loading: true,
      errored: false,

      discountId: this.$route.params.discountId
    };
  },

  computed: {
    discount: function() {
      return this.$store.getters["discounts/byId"](this.discountId);
    }
  },

  created() {
    let that = this;
    this.$store
      .dispatch("discounts/fetchOne", this.discountId)
      .catch(e => {
        console.error(e);
        that.errored = true;
      })
      .finally(() => (that.loading = false));
  }
};
</script>
